import Button from '@loggi/ui/components/button';
import Col from '@loggi/ui/components/col';
import Textarea from '@loggi/ui/components/textarea';
import View from '@loggi/ui/components/view';
import { privatePackageTrackerModel } from 'app.models';
import { matchModel } from 'app/app.models';
import getStatusPath from 'app/app.utils';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import UserFeedbackAlert from 'shared/alert/user-feedback-alert/user-feedback-alert.component';
import MainView from 'shared/main-view/main-view.component';
import { INSTRUCTIONS } from 'tracker.routes';
import ClassificationHeader from '../classification-header/classification-header.component';
import {
  FEEDBACK_ALERT_PROPS,
  RETRY_MESSAGE
} from '../classification.constants';
import ClassificationService from '../classification.service';
import {
  ADDITIONAL_RECEIVERS_PLACEHOLDER_TEXT,
  CONTINUE_BUTTON_DATA_TEST_ID,
  CONTINUE_BUTTON_TEXT
} from './additional-receivers.constants';
import styles from './additional-receivers.styles.scss';

/* eslint-disable react/jsx-props-no-spreading */
export class AdditionalReceiversContainer extends Component {
  constructor(props) {
    super(props);

    const additionalReceivers = get(
      props,
      'privatePackageTracker.destinationInfo.additionalReceivers',
      ''
    );

    this.state = {
      additionalReceivers,
      showUserFeedbackAlert: false
    };
  }

  _renderHeader = () => {
    const recipientName = get(
      this.props,
      'privatePackageTracker.recipientInfo.firstName',
      ''
    );

    const { history } = this.props;

    const headerProps = {
      onClickBack: history.goBack,
      headerText: `${recipientName}, quem mais pode receber essa entrega?`
    };

    return <ClassificationHeader {...headerProps} />;
  };

  _onChangeAdditionalReceivers = additionalReceivers => {
    this.setState({ additionalReceivers });
  };

  _failureMutationCallback = () => {
    this.setState({ showUserFeedbackAlert: true });
  };

  _succesMutationCallback = response => {
    if (!response) {
      // eslint-disable-next-line no-console
      console.error(
        `success mutation callback received ${response} as response.`
      );
      return this._failureMutationCallback();
    }
    const { history } = this.props;
    const queryString = history.location.search;

    if (queryString) {
      return history.push(`${INSTRUCTIONS}${queryString}`);
    }
    return history.push(INSTRUCTIONS);
  };

  _onSaveAdditionalReceivers = () => {
    const {
      match: {
        params: { packageId }
      }
    } = this.props;

    const { additionalReceivers } = this.state;

    const successCallback = response => this._succesMutationCallback(response);
    const failureCallback = () => this._failureMutationCallback();

    return ClassificationService.send({
      packageId,
      additionalReceivers,
      successCallback,
      failureCallback
    });
  };

  _onClickRetry = () => {
    this.setState({ showUserFeedbackAlert: false }, () => {
      return this._onSaveAdditionalReceivers();
    });
  };

  _getStatusPath() {
    const {
      match: {
        params: { packageId }
      }
    } = this.props;
    return getStatusPath(packageId);
  }

  render() {
    const { privatePackageTracker } = this.props;

    if (!privatePackageTracker) {
      return <Redirect to={this._getStatusPath()} />;
    }

    const { additionalReceivers, showUserFeedbackAlert } = this.state;

    const feedbackAlertButtonProps = [
      { value: RETRY_MESSAGE, onClick: this._onClickRetry }
    ];

    return (
      <MainView className="tracker-content classificationMainView">
        {this._renderHeader()}
        <View
          flex
          flexDirection="column"
          flexGrow="1"
          gutter={{
            top: 'double',
            left: 'double',
            right: 'double',
            bottom: 'double'
          }}
          justifyContent="between"
        >
          <Textarea
            placeholder={ADDITIONAL_RECEIVERS_PLACEHOLDER_TEXT}
            onChange={this._onChangeAdditionalReceivers}
            value={additionalReceivers}
            className={styles.additionalReceiversInfo}
          />
          <Col
            flex
            flexDirection="column"
            gutter={{
              top: 'double'
            }}
          >
            <Button
              value={CONTINUE_BUTTON_TEXT}
              data-testid={CONTINUE_BUTTON_DATA_TEST_ID}
              onClick={this._onSaveAdditionalReceivers}
            />
          </Col>
        </View>
        {showUserFeedbackAlert && (
          <UserFeedbackAlert
            {...FEEDBACK_ALERT_PROPS}
            buttonsProps={feedbackAlertButtonProps}
          />
        )}
      </MainView>
    );
  }
}

function mapStateToProps(state) {
  return {
    privatePackageTracker: state.data.privatePackageTracker
  };
}

AdditionalReceiversContainer.displayName = 'AdditionalReceiversContainer';

AdditionalReceiversContainer.propTypes = {
  privatePackageTracker: PropTypes.shape(privatePackageTrackerModel).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string
    }).isRequired
  }).isRequired,
  match: PropTypes.shape(matchModel).isRequired
};

export default connect(mapStateToProps)(AdditionalReceiversContainer);
